<template>
	<div class="home">
		<div>
			<NavBar />
			<div class="nav"></div>
			<div class="tabFlex notScroll" ref="tab" v-if="tab.length > 0">
				<img src="@/assets/images/tab_bg.png" class="tabFloat" />
				<div class="tabFlexBox">
					<div class="tabItem" v-for="(item, index) in tab" :key="index" :class="{ current: index == tabIndex }" @click="tabChange(index, $event)">{{ item.name }}</div>
				</div>
			</div>
			<div class="content">
				<div class="list" v-if="list.length > 0">
					<div class="item" v-for="(item, index) in list" :key="index" @click="goNext(item, index)">
						<div class="left">
							<div class="cover"><img v-if="item.path" :src="item.path" /></div>
							<div class="title">{{ item?.title || `` }}</div>
						</div>
						<div class="right">
							<svg viewBox="0 0 1024 1024" width="12" height="22">
								<path
									d="M723.1 483.4c-1.3-1.3-2.6-2.4-4-3.4L355.9 116c-14.6-14.6-38.4-14.6-53 0-14.6 14.6-14.6 38.5 0 53.1l340.4 341.2L302.9 851c-14.6 14.6-14.6 38.4 0 53 14.6 14.6 38.4 14.6 53 0l362.9-363.3c1.5-1.1 2.9-2.3 4.3-3.7 7.4-7.4 11-17.1 10.9-26.8 0.1-9.7-3.6-19.4-10.9-26.8z"
									fill="#991d85"
								/>
							</svg>
						</div>
					</div>
				</div>
				<div v-else class="empty">{{ loading ? '加载中...' : '暂无内容' }}</div>
			</div>
			<float-btn></float-btn>
		</div>
	</div>
</template>

<script>
import { Toast, Empty } from 'vant';
import Crypt from '@bluedot-tech/vue-ui/es/utils/crypt';
import config from '../config/config';
import floatBtn from '@/components/FloatBtn.vue';
import NavBar from '@/components/NavBar.vue';
export default {
	components: {
		floatBtn,
		[Empty.name]: Empty,
		NavBar
	},
	data() {
		return {
			tabIndex: 0,
			tab: [],
			list: [],
			loading: true
		};
	},
	mounted() {
		// 页面浏览 监测
		this.$dataStatistics({ page_title: '产品简介-分类' });
		this.initShare();
		this.getTab();
		// this.getDetails();
		// // 环境变量获取方法
		// console.log('process.env', process.env);
	},
	methods: {
		async getTab() {
			const key = localStorage.getItem('list-index');
			this.tabIndex = key * 1;
			this.$http.get('/api/platform/type').then(async (res) => {
				console.log(res);
				this.tab = res.data?.filter((item) => item?.type == 1);
				this.$nextTick(async () => {
					setTimeout(async () => {
						try {
							console.log('尝试自动点击');
							const dom = document.getElementsByClassName('tabItem');
							dom[key].click();
							console.log('自动点击成功');
						} catch (err) {
							console.log('自动点击失败');
							this.getList();
						}
					}, 300);
				});
			});
		},
		getList() {
			this.list = [];
			this.loading = true;
			this.$http.get(`/api/platform/module?filter[type]=3&filter[s_type]=${this.tab[this.tabIndex]?.id}`).then((res) => {
				console.log(res);
				this.list = res.data;
				this.loading = false;
			});
		},
		tabChange(index, e) {
			console.log(e);
			let dom = e.target;
			this.tabIndex = index;
			this.$refs.tab.scrollLeft = dom.offsetLeft - dom.offsetWidth; //左侧留出一个身位
			localStorage.setItem('list-index', index);

			let html = document.getElementsByTagName('html')[0];
			let page = document.getElementsByTagName('body')[0];
			setTimeout(() => {
				html.scrollTop = 0;
				page.scrollTop = 0;
				this.getList();
			}, 0);
		},
		goNext(item, index) {
			console.log(item);
			this.$dataStatistics({ event_type: 'click', page_title: '产品简介-分类' }, JSON.stringify({ title: `${item.name}`, id: item.id }));
			this.$router.push({ path: '/list', query: { id: item.id, navId: this.tab[this.tabIndex]?.id } });
		}
	}
};
</script>
<style lang="less" scoped>
.home {
	background: rgba(249, 247, 243, 0.66);

	.tabFlex {
		position: fixed;
		z-index: 9;
		top: 110px;
		left: 0;
		width: 828px;
		height: 90px;
		overflow-x: auto;
		overflow-y: hidden;

		.tabFloat {
			position: fixed;
			right: 0;
			top: 110px;
			z-index: 11;
			width: 60px;
			height: 90px;
		}

		.tabFlexBox {
			height: 100%;
			white-space: nowrap;
			word-wrap: normal;
			word-break: normal;
			display: flex;
			align-items: center;

			.tabItem {
				height: 100%;
				padding: 0 36px;
				flex: 0 0 auto;
				display: flex;
				align-items: center;
				justify-content: center;
				position: relative;
				font-size: 28px;
				font-weight: normal;
				color: #000000;
				line-height: 1;

				// &::after {
				// 	position: absolute;
				// 	top: 50%;
				// 	right: 0;
				// 	content: '';
				// 	display: block;
				// 	width: 1.5px;
				// 	height: 32px;
				// 	background-color: #999999;
				// 	transform: translateY(-50%);
				// }

				// &:last-child {
				// 	&::after {
				// 		display: none;
				// 	}
				// }

				&::before {
					position: absolute;
					left: 50%;
					bottom: 0;
					content: '';
					display: block;
					width: calc(100% - 36px - 36px);
					height: 4px;
					background-color: @theme;
					transform: translate(-50%, 110%);
					transition: all 0.35s;
				}

				&.current {
					font-weight: bold;
					font-size: 34px;
					color: @theme;
					line-height: 1;

					&::before {
						transform: translate(-50%, 0);
					}
				}
			}
		}
	}

	.content {
		width: 828px;
		position: relative;
		overflow-y: auto;
		height: auto;
		z-index: 6;

		.empty {
			position: fixed;
			top: 55%;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: 1;
		}

		.list {
			overflow: hidden;
			display: block;
			padding: 36px;

			.item {
				padding: 30px 26px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				background: #ffffff;
				border-radius: 10px;
				margin-bottom: 32px;
				box-shadow: 0px 0 12px 6px rgba(0, 0, 0, 0.04);

				.cover {
					flex: 0 0 auto;
					width: 236px;
					height: 140px;
					display: block;
					margin-right: 30px;

					img {
						width: 100%;
						height: 100%;
						display: block;
						object-fit: cover;
					}
				}

				.title {
					font-size: 30px;
					font-weight: 400;
					color: #000000;
					line-height: 48px;
					white-space: pre-line;
					word-wrap: break-word;
					word-break: break-word;
				}

				.left {
					display: flex;
					align-items: center;
				}

				.right {
				}
			}
		}
	}
}
</style>
